import axios from 'axios';

const fetchLegislatorBills = async (legislator) => {
    try {
        const currentSessions = legislator.legislatorDetails.sessionMemberships.map((session) => {
            return {sessionId: session.session.id, legislatorId: legislator.legislatorDetails.id};
        });

        const searchParams = {
            sessionIds: currentSessions.map(session => session.sessionId),
            sponsorIds: [legislator.legislatorDetails.id]
        };

        const response = await axios.post(
            `${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1/bills/search`,
            searchParams,
            {
                params: {
                    includeCounts: false,
                    sort: ['billNumber,asc'],
                    limit: 100000,
                    offset: 0
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
}; 


const fetchBillCategorization = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1/billProgressCategories`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

const categorizeBills = (billsData, billCategorization) => {
    const categorization = {
        introduced: 0,
        passed: 0,
        failed: 0,
        tabled: 0
    };

    if (!billsData?.content || !billsData.content.length || !billCategorization) {
        console.log('Missing data:', { 
            hasBillsData: !!billsData?.content, 
            billsLength: billsData?.content?.length, 
            hasCategorization: !!billCategorization 
        });
        return categorization;
    }

    // Mapping the status codes to the categories (Need to check with suzi)
    const statusMaps = {
        introduced: new Set(billCategorization
            .filter(cat => parseInt(cat.code) >= 20)
            .map(cat => cat.code)),
        passed: new Set(billCategorization
            .filter(cat => cat.description === "Became Law")
            .map(cat => cat.code)),
        failed: new Set(billCategorization
            .filter(cat => cat.description === "Probably Dead")
            .map(cat => cat.code)),
        tabled: new Set(billCategorization
            .filter(cat => cat.description.includes("Tabled"))
            .map(cat => cat.code))
    };


    billsData.content.forEach(bill => {
        // Get the latest status from billStatuses array
        const latestStatus = bill.draft?.billStatuses
            ?.sort((a, b) => new Date(b.timeStamp) - new Date(a.timeStamp))[0];

        if (!latestStatus?.billStatusCode?.billProgressCategory?.code) {
            console.log('No status code found for bill:', bill.id);
            return;
        }

        const statusCode = latestStatus.billStatusCode.billProgressCategory.code;

        // Check each category using the status maps
        if (statusMaps.introduced.has(statusCode)) {
            categorization.introduced++;
        }
        if (statusMaps.passed.has(statusCode)) {
            categorization.passed++;
        }
        if (statusMaps.failed.has(statusCode)) {
            categorization.failed++;
        }
        if (statusMaps.tabled.has(statusCode)) {
            categorization.tabled++;
        }
    });

    // Caulculating for percentages (Need to check with suzi)
    const total = categorization.introduced || 1;
    categorization.passedPercentage = ((categorization.passed / total) * 100).toFixed(1);
    categorization.failedPercentage = ((categorization.failed / total) * 100).toFixed(1);
    categorization.tabledPercentage = ((categorization.tabled / total) * 100).toFixed(1);
    categorization.introducedPercentage = "100.0";

    return categorization;
};


const fetchBillVotes = async (billId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1/votes/findByBillId?billId=${billId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};
export { fetchLegislatorBills, fetchBillCategorization, categorizeBills, fetchBillVotes };